module.exports = __webpack_public_path__ + "static/media/Dra-Mariela-Baleiron.e726de54.jpg";